import { useState } from "react";

import { AppMenuButton } from "./AppMenuButton";
import { AppMenuPopover } from "./AppMenuPopover";

const AppMenu = () => {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState();

  return (
    <>
      <AppMenuButton onClick={() => setOpen(true)} setAnchorEl={setAnchorEl} />
      <AppMenuPopover
        open={open}
        onClose={() => setOpen(false)}
        anchorEl={anchorEl}
      />
    </>
  );
};

export default AppMenu;
